<div
  class="pie-chart"
  data-test="pie-chart"
  role="img"
  [ngStyle]="{ height: size + 'px', 'aspect-ratio': 1 }"
  [sgSkeleton]="isLoading"
  skeletonShape="donut"
  [@chartAnimation]="getAnimationState()">
  <svg class="pie-svg" [attr.width]="getSvgSize()" [attr.height]="getSvgSize()" [attr.viewBox]="getViewBox()">
    <defs>
      <!-- Create the glow effect -->
      <filter [id]="glowFilterId" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="glow" />
        <feColorMatrix in="glow" type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" result="glowFinal" />
        <feMerge>
          <feMergeNode in="glowFinal" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    @for (path of getSvgPaths(); track i; let i = $index) {
      <g>
        @if (path.glow) {
          <path [attr.d]="path.d" [attr.fill]="path.color" stroke="none" [attr.filter]="'url(#' + glowFilterId + ')'" opacity="0.6" />
        }
        <path [attr.d]="path.d" [attr.fill]="path.color" stroke="none" />
      </g>
    }
  </svg>
  <div class="content" [@fadeInOut]="isLoading ? 'out' : 'in'"><ng-content></ng-content></div>
</div>
